import React, { Component } from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import _ from "lodash";

// Icons
import SearchIcon from "@material-ui/icons/Search";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import Grid from "@material-ui/core/Grid";

// Local modules
import PlayerList from "./PlayerList";
import PlayerDialog from "./PlayerDialog";
import AceTheme from "../../util/aceTheme";
import Styles from "./styles";
import Store from "./Store";
import Paper from "@material-ui/core/Paper";

@observer
class AgentConfig extends Component {
  state = {
    open: false,
    anchorEls: [],
    player: {},
    title: "",
  };

  render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={AceTheme}>
        <div className={classes.topContainer}>
          <Grid
            container
            spacing={0}
            className={classes.topBar}
            justify="center"
            alignItems="center"
          >
            <Grid item xs={4}>
              <TextField
                {...{
                  id: "search-agent",
                  label: "Find agent...",
                  type: "search",
                  className: classes.textField,
                  margin: "none",
                  onChange: (evt) => {
                    Store.searchTerm(evt.target.value);
                  },
                  onKeyPress: (ev) => {
                    if (ev.key === "Enter") {
                      // Do code here
                      ev.preventDefault();
                      Store.getPlayertList();
                    }
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                {...{
                  variant: "raised",
                  color: "primary",
                  className: classes.button,
                  fullWidth: true,
                  onClick: () => Store.getPlayertList(),
                }}
              >
                <SearchIcon className={classes.leftIcon} />
                FIND
              </Button>
            </Grid>
            <Grid item xs={5} />
          </Grid>
          {Store.loading && _.isEmpty(Store.playerList) && (
            <LinearProgress className={classes.progressLinear} />
          )}
          <Grid container spacing={0} className={classes.content}>
            {!_.isEmpty(Store.playerList) && (
              <Paper className={classes.paper}>
                <PlayerList
                  {...{
                    classes: classes,
                    playerList: Store.playerList,
                    anchorEls: this.state.anchorEls,
                    handleClick: (idPlayer, event) =>
                      this.handleClickMenu(idPlayer, event),
                    handleClose: this.handleCloseMenu,
                  }}
                />
              </Paper>
            )}
            {Store.displayError !== "" && _.isEmpty(Store.playerList) && (
              <Grid item xs={12}>
                {Store.displayError}
              </Grid>
            )}
            <Button
              {...{
                variant: "fab",
                color: "primary",
                className: classes.addPlayerbutton,
                onClick: this.handleClickOpen.bind(
                  this,
                  "Add new Player config",
                  Store.newPlayer
                ),
                disabled: _.isEmpty(Store.playerList),
              }}
            >
              <PersonAddIcon />
            </Button>
            <PlayerDialog
              {...{
                player: this.state.player,
                isOpen: this.state.open,
                title: this.state.title,
                handleClose: this.handleClose,
                updateField: (player, field, txt, isEdit) =>
                  Store.updateField(player, field, txt, isEdit),
                idAgent: _.get(Store.playerList[0], "IdAgent", "-1"),
              }}
            />
          </Grid>
        </div>
      </MuiThemeProvider>
    );
  }

  handleClickOpen = (title, player) => {
    this.setState({ open: true, title: title, player: player });
  };

  handleClose = (player = {}) => {
    if (
      (_.includes(this.state.title, "Edit player") ||
        _.includes(this.state.title, "Edit agent")) &&
      !_.isEmpty(player)
    ) {
      Store.editPlayer(player);
    } else if (
      !_.includes(Store.PlayerList, player.Player) &&
      !_.isEmpty(player)
    ) {
      player.Player = Store.newPlayer.Player;
      Store.createPlayer(player);
    } else {
      Store.getPlayertList();
    }
    this.setState({ open: false });
  };

  handleClickMenu = (idPlayer, event) => {
    const currentAnchorEls = this.state.anchorEls;
    currentAnchorEls[idPlayer] = event.currentTarget;
    this.setState({ anchorEls: currentAnchorEls });
  };

  handleCloseMenu = (idPlayer, action = "", player) => () => {
    const currentAnchorEls = this.state.anchorEls;
    currentAnchorEls[idPlayer] = null;
    this.setState({ anchorEls: currentAnchorEls });

    if (action === "edit") {
      const title =
        player.Player === "" || player.Player === "DEFAULT"
          ? `Edit agent ${player.Agent}`
          : `Edit player ${player.Player}`;
      this.handleClickOpen(title, player);
    } else if (action === "delete") {
      Store.deletePlayer(player.IdAgent, player.IdPlayer);
    }
  };
}

AgentConfig.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  playerList: PropTypes.arrayOf(PropTypes.object),
};

export default compose(
  withStyles(Styles, {
    name: "AgentConfig",
    withTheme: true,
  })
)(AgentConfig);
